import { NgClass } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit } from '@angular/core';
import { NgbCollapse } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { AccordionItem } from '../accordion.model';
import { ACCORDION_ITEM } from '../accordion.tokens';


@Component({
    selector: 'app-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    providers: [{ provide: ACCORDION_ITEM, useExisting: forwardRef(() => AccordionItemComponent) }],
    imports: [NgClass, NgbCollapse]
})
export class AccordionItemComponent implements AccordionItem, OnInit {
	@Input() public className?: string;
	@Input() public id: number;
	@Input() initOpen?: boolean;
	public isOpen: boolean;
	@Input() public fitPaddingToHeader = false
	@Input() public noPadding = false
	@Input() public centerTitle = false;
	public itemToggled = new EventEmitter<number>();

	constructor() {
	}
	ngOnInit(): void {
		if (this.initOpen) {
			this.isOpen = true;
		}
	}
}
